import { gql } from '@apollo/client';
import { CRM_CONTRACT_TEMPLATE_FIELDS } from './queries';

export const CREATE_CRM_CONTRACT_TEMPLATE = gql`
    mutation CreateCrmContractTemplate($input: CreateCrmContractTemplateInput!) {
        createCrmContractTemplate(input: $input) {
            ${CRM_CONTRACT_TEMPLATE_FIELDS}
        }
    }
`;

export const UPDATE_CRM_CONTRACT_TEMPLATE = gql`
    mutation UpdateCrmContractTemplate($input: UpdateCrmContractTemplateInput!) {
        updateCrmContractTemplate(input: $input) {
            ${CRM_CONTRACT_TEMPLATE_FIELDS}
        }
    }
`;

export const ARCHIVE_CRM_CONTRACT_TEMPLATE = gql`
    mutation ArchiveCrmContractTemplate($templateId: String!) {
        archiveCrmContractTemplate(templateId: $templateId) {
            _id
            name
            status
        }
    }
`;
